import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../login/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private _loginService: LoginService,
    private _router: Router
  ) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkLogin(state.url)
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkLogin(state.url)
  }

  private checkLogin(redirectUrl: string): boolean | Promise<boolean> {
    if (this._loginService.isLoggedIn) {
      if (this._loginService.hasInfo) {
        return true;
      }
      // Token exists but user-info cookie is missing: recover it instead of
      // logging the user out. Never clear tokens here.
      return this._loginService.getUserInfo().then(() => true).catch(() => true);
    }
    this.redirectApp(redirectUrl);
    return false;
  }
  redirectApp(redirectUrl: string): void {
    this._router.navigate(
      ['/login'], {
      queryParams: {
        redirect_to: redirectUrl.includes('login') ? undefined : redirectUrl
      }
    }
    );
  }


}
